// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__29zw_","description":"PatientConsentPreview_description__xGCAa"};